import { Component, ComponentRef, ContentChildren, ElementRef, HostListener, Input, QueryList, ViewChild } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { TipPosition } from "@edp-models/edp-tooltip.model";
import { sleep } from "@edp-utils/sleep.utils";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";


@Component({
    selector: "edp-tooltip",
    templateUrl: "./edp-tooltip.component.html",
    styleUrls: ["./edp-tooltip.component.scss"],
})
export class EdpTooltipComponent {
    @Input() public tipPosition: TipPosition;
    @Input() modalComponent: ComponentRef<any>;
    @ViewChild("tooltip", { static: false }) tooltip: ElementRef<HTMLElement>;

    public mobileSize = false;
    public showTooltip = false;

    constructor(private edpModalService: EdpModalService, private elementRef: ElementRef) {
        this.onResize();
    }

    @HostListener("document:click", ["$event"])
    clickout(event: { target: Node }) {
        if (!!this.tooltip && !!this.showTooltip) {
            const filterPickerContainer = this.tooltip.nativeElement;
            const parentTooltip = this.elementRef.nativeElement;
            const isClickedInsideTooltip = parentTooltip.contains(event.target as Node);

            if (filterPickerContainer && !filterPickerContainer.contains(event.target) && !isClickedInsideTooltip) {
                this.showTooltip = false;
            }
        }
    }

    @HostListener("window:resize")
    private onResize() {
        this.mobileSize = false;
        if (window.innerWidth < SCREEN_SIZES.WDGT) {
            this.mobileSize = true;
        }
    }

    public async fireTooltip() {
        if (this.mobileSize && !!this.modalComponent) {
            this.fireModal();
            return;
        }
        this.showTooltip = !this.showTooltip;
    }

    public fireModal() {
        const modalOptions: NgbModalOptions = { windowClass: "edp-modal-window modal-filter-picker" };
        const data = {};
        this.edpModalService.custom(this.modalComponent, modalOptions, data).then(() => {
            /* intentional event resolve */
        });
    }
}
